// res/modules/react-native-fbsdk-next.web.ts

export const LoginManager = {
  logInWithPermissions: () => Promise.resolve({ isCancelled: true }),
  logOut: () => {},
};

export const AccessToken = {
  getCurrentAccessToken: () => Promise.resolve(null),
};

export class GraphRequest {
  constructor(_path?: string, _config?: any, _callback?: any) {}
  start() {}
}

export class GraphRequestManager {
  addRequest(_req: any) {
    return this;
  }
  start() {}
}

// 🚀 Stub do AppEventsLogger
export const AppEventsLogger = {
  logEvent: (eventName: string, params?: any) => {
    console.log(`[FBSDK Stub] logEvent: ${eventName}`, params);
  },
  logPurchase: (amount: number, currency: string, params?: any) => {
    console.log(`[FBSDK Stub] logPurchase: ${amount} ${currency}`, params);
  },
  setUserID: (id: string) => {
    console.log(`[FBSDK Stub] setUserID: ${id}`);
  },
  flush: () => {
    console.log('[FBSDK Stub] flush()');
  },
};
